import type { ComponentChildren, FunctionComponent } from "preact";
import { useMergedClassName } from "../utils.ts";

type SectionProps = {
    title?: string;
    description?: string;
    children: ComponentChildren;
    class?: string;
};

export const Section: FunctionComponent<SectionProps> = (props: SectionProps) => {
    const className = useMergedClassName("farpov_section", props.class);
    
    return (
        <section class={className}>
            {(props.title || props.description) && (
                <div class="farpov_section_header">
                    {props.title && <h4 class="farpov_section_title">{props.title}</h4>}
                    {props.description && <p class="farpov_section_desc">{props.description}</p>}
                </div>
            )}
            <div class="farpov_section_content">
                {props.children}
            </div>
        </section>
    );
};
